import { jsx, jsxs } from 'react/jsx-runtime';
import React__default from 'react';
import { styled } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import { IndexingIcon } from '@fabric-app/icons/icons';
import { isResourceStateProcessing } from '../utils/isResourceStateProcessing.js';

const StateSpinnerContainer = styled.div.withConfig({
  displayName: "StateSpinner__StateSpinnerContainer",
  componentId: "sc-ea6621e9-0"
})([
  `position:relative;display:flex;justify-content:center;align-items:center;color:`,
  `;--spinner-size:`,
  `px;width:var(--spinner-size);height:var(--spinner-size);`
], (props) => props.color ?? cssVar["color-app-primary"], (props) => props.size ?? 48);
const IconWrapper = styled.div.withConfig({
  displayName: "StateSpinner__IconWrapper",
  componentId: "sc-ea6621e9-1"
})([
  `display:flex;position:absolute;align-items:center;justify-content:center;pointer-events:none;width:var(--spinner-size);height:var(--spinner-size);`
]);
const useResourceLoadingStateIndicatorProps = (resource) => {
  const isIndexing = isResourceStateProcessing(resource?.stateProcessing);
  const isDraft = Boolean(resource?.isDraft);
  const isLoadingState = isIndexing || isDraft;
  return {
    showIndicator: isLoadingState,
    isIndexing
  };
};
const StateSpinner = /* @__PURE__ */ React__default.forwardRef(({ isIndexing, size, color, loadingTooltip, ...props }, ref) => {
  return /* @__PURE__ */ jsx(Tooltip, {
    label: isIndexing ? "Indexing and analyzing with AI" : loadingTooltip,
    children: /* @__PURE__ */ jsxs(StateSpinnerContainer, {
      ref,
      size,
      color,
      children: [
        !isIndexing && /* @__PURE__ */ jsx(Spinner, {
          size,
          ...props
        }),
        isIndexing && /* @__PURE__ */ jsx(IconWrapper, {
          style: {
            width: size,
            height: size
          },
          children: /* @__PURE__ */ jsx(IndexingIcon, {
            size: Math.round((size ?? 48) / 2.2)
          })
        })
      ]
    })
  });
});
StateSpinner.displayName = "StateSpinner";

export { StateSpinner as default, useResourceLoadingStateIndicatorProps };
//# sourceMappingURL=StateSpinner.js.map
